import gql from 'graphql-tag'
import { channelBaseFragment } from 'remote/channels'
import { dataFetched } from 'data/graphql'

export const fetchAllChannels = () => ({ dispatch, graphQLClient }) => {
  return {
    type: 'FETCH_ALL_CHANNELS',
    payload: {
      promise: graphQLClient
        .mutate({
          query: gql`
            query fetchAllUserChannels {
              me {
                __typename
                id
                channels {
                  ...channelBaseAttrs
                }
              }
            }
            ${channelBaseFragment}
          `,
        })
        .then(({ data }) => {
          dispatch(dataFetched(data.me.channels))
        }),
    },
  }
}
